import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Spin, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import useFetch from 'utils/fetch/useFetch';
import { ME } from 'api';
import Info from './components/Info';
import Rights from './components/Rights';
import Tape from './components/Tape';

function Profile({}) {
  const [view, setView] = useState('profile');
  const {t} = useTranslation();
  const { data,  loading, updateData } = useFetch(ME, {
    uniqId: 'me',
    autoFetch: true
  });

  return (
    <Spin spinning={loading}>
      {view === 'profile' ? (
        <Row gutter={[20, 10]}>
          <Col span={6}>
            <div className="mb-28 items-center flex justify-between">
      <div className="text-20 text-black font-semibold">{t('profile')}</div>
              <Button
                onClick={() => {
                  setView('tape');
                }}
                className="text-primary pr-0 flex items-center"
                type="link"
              >
                <span className="border-b-1 border-dotted">
                  {t('watchTheEventFeed')}
                </span>
              </Button>
            </div>
            {data && <Info updateData={updateData} data={data} />}
          </Col>
          <Col span={18}>
            {data  && data.warehouse_permissions.length === 0 ? <Empty className="mt-50"/> : data && data.warehouse_permissions && <Rights data={data.warehouse_permissions}/>}
          </Col>
        </Row>
      ) : (
        <Tape />
      )}
    </Spin>
  );
}

Profile.propTypes = {};

export default Profile;
